module.exports = __webpack_public_path__ + "img/cleaver_ios_802.png";